import styled from "styled-components";

export const MixerCotainer = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: end;
`